<nb-card size="large" status="success" class="team-players-modal">
    <nb-card-body class="team-list">
        <div *ngFor="let player of participantes" class="team-player">
            <div class="team-player__ranking">
                <span>{{ player.posicao_ranking ? player.posicao_ranking + "º" : "-" }}</span>
            </div>

            <div class="team-player__content">
                <div class="team-player__img">
                    <img [src]="player.avatar" width="60px" />
                </div>
                <div>
                    <!-- prettier-ignore -->
                    <span class="d-block "><strong>{{ player.nome_abreviado }}</strong> <span *ngIf="player.capitao_equipe == 1" [ngClass]="['badge', 'badge-success']">{{ "TEAM-PLAYER-CAPTAIN" | translate }}</span></span>
                    <span class="d-block">{{ player.cidade }} / {{ player.uf }} </span>
                    <span class="">{{ player.idade }} anos</span>
                </div>

                <app-wtn-point
                    [point]="player.wtn?.single ? player.wtn?.single?.format : player.wtn?.double?.format"
                    [tooltip]="player.wtn.single ? player.wtn.single?.title : player.wtn.double?.title"
                    *ngIf="player.wtn"
                    class="ml-3"
                ></app-wtn-point>
            </div>
        </div>
    </nb-card-body>
</nb-card>
